import { CSSObject } from '@chakra-ui/react';

export const Wrapper: CSSObject = {
  h: ['50px', null, '108px'],
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

export const TextItem = {
  color: '#FFF',
  textAlign: 'center',
  fontSize: '13px',
  fontStyle: 'normal',
  fontWeight: '400',
};

export const LinkItem = {
  color: 'delta.400',
  fontWeight: 'bold',
};
